import { PlanV2 } from '@zapier/design-system-revenue/src/types';

export const features = [
  {
    hasFeature: (plan: PlanV2) => plan.hasAutoReplay,
    helpText: 'What is this?',
    helpUrl: '/help/autoreplay',
    key: 'hasAutoReplay',
    name: 'Autoreplay',
  },
  {
    hasFeature: (plan: PlanV2) => plan.hasPaths,
    helpText: 'What is this?',
    helpUrl: '/help/paths',
    key: 'hasPaths',
    name: 'Paths',
  },
  {
    hasFeature: (plan: PlanV2) => plan.hasMeteredBilling,
    helpText: 'What is this?',
    helpUrl: '/teams/#teams-pricing',
    key: 'hasMeteredBilling',
    name: 'Metered Billing',
  },
  {
    hasFeature: (plan: PlanV2) => plan.hasMultiStepZaps,
    helpText: 'What are these?',
    helpUrl: '/learn/getting-started-guide/multi-step-zaps',
    key: 'hasMultiStepZaps',
    name: 'Multi-Step Zaps',
  },
  {
    hasFeature: (plan: PlanV2) => plan.hasPremiumApps,
    helpText: 'View All Premium Apps',
    helpUrl: '/apps/categories/premium',
    key: 'hasPremiumApps',
    name: 'Premium Apps',
  },
  {
    hasFeature: (plan: PlanV2) => plan.hasTeams,
    helpText: 'What is this?',
    helpUrl: '/help/team-accounts',
    key: 'hasTeams',
    name: 'Teams',
  },
];
